import './levels/levels.scss';

import React, { useState } from "react";

import { RegisterProps } from "../../../types/helpers";
import { LevelsInfo } from "./levels/standard";
import { ActionButton } from '../../utils/action-button/actionButton';
import { AllLevels, LevelInfoDetailsArray, LevelsInfoDetails } from '../../../types/register';

export const RegisterIntro : React.FC<RegisterProps> = (props) => {

    //const dispatch = useAppDispatch();
    const details : AllLevels = LevelInfoDetailsArray;

    const [level, setLevel] = useState('default');
    const [levelInfo, setLevelInfo] = useState<LevelsInfoDetails>(details.default);

    const handleChange = (category
            : 'default' | 'advanced' | 'premium') => {
        setLevel(category
                
        );
        setLevelInfo(details[category
                
        ])
    }

    const handleNavigation = () => {
        props.increaseStep();
    }

    return (
        <div className="register-intro">
            
            <h1>Níveis de acesso</h1>
            <p>abaixo uma lista de beneficios e limites</p>

            <div className="card">

                <div className="card-header">
                    <ul>
                        <li className={ level === 'default' ? 'active' : 'none' } 
                            onClick={() => handleChange('default')}>
                            <div></div>
                            <span>Padrão</span>
                        </li>
                        <li className={ level === 'advanced' ? 'active' : 'none' } 
                            onClick={() => handleChange('advanced')}>
                            <div></div>
                            <span>Avançado</span>
                        </li>
                        <li className={ level === 'premium' ? 'active' : 'none' } 
                            onClick={() => handleChange('premium')}>
                            <div></div>
                            <span>Premium</span>
                        </li>
                    </ul>
                </div>

                <div className="card-body">
                    <LevelsInfo 
                        data={levelInfo}
                    />
                </div>

                <ActionButton label="continuar" onClick={ handleNavigation } stylish='btn-green' />
            </div>
        </div>
    )
}